import React, { useContext } from "react";
import { ArrowUturnLeftIcon, CheckCircleIcon, ClockIcon, DocumentTextIcon } from "@heroicons/react/24/outline";
import Button from "src/components/form/Button";
import { AuthContext } from "src/context/auth";
import { RenderQuestionField } from "src/helpers/formHelper";

export default function FormResponse({ response, onStartNewSubmission, hideSubmission, navigateToAll }) {
  const { user } = useContext(AuthContext);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <>
      <div className="mb-6 rounded-lg bg-white p-8 text-center shadow">
        {!hideSubmission && (
          <>
            <div className="mb-4 flex justify-center">
              <CheckCircleIcon className="h-16 w-16 text-highlightColor" />
            </div>
            <h1 className="mb-2 text-3xl font-bold text-gray-800">{response?.message || "Form Submitted Successfully!"}</h1>
            <p className="mb-4 text-gray-600">Thank you for your submission. Your response has been recorded.</p>
          </>
        )}
        <div className="mb-6 rounded-lg bg-gray-50 p-4">
          <div className="flex items-center justify-center space-x-6 text-sm text-gray-600">
            <div className="flex items-center space-x-2">
              <ClockIcon className="h-4 w-4" />
              <span>Submitted: {formatDate(response?.created_at)}</span>
            </div>
          </div>
        </div>

        {!hideSubmission && (
          <div className="flex justify-center space-x-4">
            {response?.allow_multiple_submissions && (
              <Button
                buttonFunction={onStartNewSubmission}
                buttonIcon={ArrowUturnLeftIcon}
                buttonIconClass="!h-4 !w-4"
                buttonIconPosition="left"
                buttonClasses="!bg-highlightColor hover:!bg-highlightColor/90 !gap-3 !h-11"
                buttonLabel="Submit Another Response"
              />
            )}
            {user?._id && (
              <Button
                buttonFunction={navigateToAll}
                buttonIcon={DocumentTextIcon}
                buttonIconPosition="left"
                buttonIconClass="!h-4 !w-4"
                buttonClasses="relative overflow-hidden !bg-white !text-highlightColor !border border-highlightColor !font-medium !h-11 !gap-3"
                buttonLabel="All Submissions"
              />
            )}
          </div>
        )}
        <div className="mt-2 p-2">
          <h2 className="text-xl font-semibold text-gray-800">Your Responses</h2>
          <p className="mt-1 text-gray-600">Below are all the answers you provided in this form.</p>
        </div>
      </div>

      <div className="rounded-lg bg-white shadow">
        <div className="p-6">
          <div className="space-y-6">
            {response?.form_details?.sections?.map((section) => (
              <div
                className="space-y-3"
                key={section?._id}>
                {section?.contents?.map((contentItem) => (
                  <div key={contentItem?._id}>
                    {contentItem?.type === "title" && (
                      <div className="rounded-lg border-l-4 border-highlightColor bg-white p-6 shadow">
                        <h1 className="mb-2 text-2xl font-bold text-gray-800">{contentItem?.name}</h1>
                        {contentItem?.description && <p className="leading-relaxed text-gray-600">{contentItem?.description}</p>}
                      </div>
                    )}

                    {contentItem?.type === "question" && (
                      <div className="rounded-lg bg-white p-6 shadow">
                        <RenderQuestionField
                          response={true}
                          content={contentItem}
                          answers={response?.answers}
                          dateOfSigning={formatDate(response?.created_at)}
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
